import React from 'react';
import { connect } from 'react-redux';
import './IconToggleButtons.scss';

// Import the icons (you'll need to add these PNG files to the component folder)
import eyeIcon from './eye-alt.png';
import eyeCloseIcon from './eye-close.png';
import infoIcon from './info-empty.png';

import { toggleEyeButton, toggleInfoButton } from 'store/actions';
import { createPortal } from 'react-dom';

const IconToggleButtons = ({
  eyeButtonActive,
  infoButtonActive,
  toggleEyeButton,
  toggleInfoButton,
}) => {
  const handleEyeButtonClick = () => {
    toggleEyeButton(!eyeButtonActive);
    console.log('Eye button clicked');
  };

  const handleInfoButtonClick = () => {
    toggleInfoButton(!infoButtonActive);
    console.log('Info button clicked');
  };

  return createPortal(
    <div className="icon-toggle-buttons">
      <button
        className={`icon-button icon-button--eye ${
          eyeButtonActive ? 'active' : ''
        }`}
        onClick={handleEyeButtonClick}
        aria-label="Eye view"
      >
        <img src={eyeButtonActive ? eyeIcon : eyeCloseIcon} alt="Eye icon" />
      </button>

      <button
        className={`icon-button icon-button--info ${
          infoButtonActive ? 'active' : ''
        }`}
        onClick={handleInfoButtonClick}
        aria-label="Information"
      >
        <img src={infoIcon} alt="Info icon" />
      </button>
    </div>,
    document.body
  );
};

const mapStateToProps = (state) => ({
  eyeButtonActive: state.iconButtons.eyeButtonActive,
  infoButtonActive: state.iconButtons.infoButtonActive,
});

const mapDispatchToProps = {
  toggleEyeButton,
  toggleInfoButton,
};

export default connect(mapStateToProps, mapDispatchToProps)(IconToggleButtons);
